<template>
  <div>
    <base-title
      title="Foody Delivery"
      subtitle="Integrações"
      link="integracoes"
    />

    <div class="integration-details">
      <div class="header">
        <div class="wrapper">
          <p class="title">Se cadastre no Foody Delivery</p>
          <img
            src="@/assets/img/integration.svg"
            class="img-fluid mobile"
            alt="Integrações"
          />
          <p class="description">
            Plataforma de logística urbana para estabelecimento delivery ou
            empresa de entregas. Rastreamento de entregadores, planejamento de
            rotas, distribuição automática de entregas para deixar sua operação
            logística automatizada.
          </p>
        </div>
        <img
          src="@/assets/img/integration.svg"
          class="img-fluid desktop"
          alt="Integrações"
        />
      </div>

      <div class="register">
        <base-button
          text="Cadastrar"
          class="big w-100"
          @click="changeRoute('foody-delivery-cadastro')"
        />

        <div class="help">
          <p>Tem dúvidas? Acesse&nbsp;</p>
          <a
            href="https://ajuda.easydelivery.com.br/apis-e-integracoes/"
            target="_blank"
            class="link"
            >https://ajuda.easydelivery.com.br/</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/css/veasy/integrations.css';

import { mapState } from 'vuex';

// mixin
import deliveryConfiguration from '@/mixins/deliveryPlatformConfig.js';

import BaseTitle from '@/components/Title';
import BaseButton from '@/components/Button';

export default {
  data() {
    return {
      seeMoreAbout: false,
      seeMoreConditions: false,
    };
  },
  components: {
    BaseTitle,
    BaseButton,
  },
  mixins: [deliveryConfiguration],
  methods: {
    changeRoute(routeName) {
      this.$router.push({ name: routeName });
    },
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.store.isMobile,
    }),
  },
};
</script>
